import type { HearingLossAssessmentDataV2 } from '@common/validation/customControls/hearingLoss/hearingLossAssessment/hearingLossAssessmentV2';
import type { HearingLossAssessmentDataV3 } from '@common/validation/customControls/hearingLoss/hearingLossAssessment/hearingLossAssessmentV3';
import { CustomControlCode } from '@common/enums';
import { CustomControlRegistry } from '@frontend/components/pages/episodeCategory/customControls/customControlRegistry';
import { HearingLossAssessmentEditV2 } from './v2/HearingLossAssessmentEditV2';
import { HearingLossAssessmentEditV3 } from './v3/HearingLossAssessmentEditV3';
import { HearingLossAssessmentReadV3 } from './v3/HearingLossAssessmentReadV3';

const code = CustomControlCode.HearingLossAssessment;

CustomControlRegistry.instance.register<HearingLossAssessmentDataV2>({
    EditElement: HearingLossAssessmentEditV2,
    code,
    version: 2,
});

CustomControlRegistry.instance.register<HearingLossAssessmentDataV3>({
    EditElement: HearingLossAssessmentEditV3,
    ReadElement: HearingLossAssessmentReadV3,
    code,
    version: 3,
});
